// extracted by mini-css-extract-plugin
export default {"container":"container__kudHy","circle":"circle__2JmJe","roundedSquare":"roundedSquare__y6z3H","thickCircle":"thickCircle__Mt0C7","thinCircle":"thinCircle__2tILP"};